module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spinner spinner--rotate-diamond",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52d38cb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Diamond.vue
// module id = 648
// module chunks = 1